export default __webpack_public_path__ + "static/media/XRP.564508aa.svg";